import { InfoCircleOutlined } from "@ant-design/icons";
import { Divider, Modal } from "antd";
import { SidepanelStyles } from "constants/index";

export default function ViewSelectedItemsDrawer(props: {
  items: Array<{ name: string; pre?: string }>;
  instruction: string;
  setOpen: (open: boolean) => void;
  isOpen: boolean;
  title: string;
}) {
  const { items, instruction, setOpen, isOpen, title } = props;

  return (
    <Modal
      className="custom-drawer"
      data-testid="viewselecteditemsdrawer-modal"
      title="Selection Details"
      width={420}
      style={SidepanelStyles.style}
      styles={{ body: { minHeight: "calc(100vh - 32px)" } }}
      footer={null}
      open={isOpen}
      onCancel={() => {
        setOpen(false);
      }}
      destroyOnHidden
    >
      <div
        className="flex pt-2 items-center justify-center text-xs"
        data-testid="viewselecteditemsdrawer-instruction"
      >
        <InfoCircleOutlined className="pr-1" /> {instruction}
      </div>
      <Divider />
      <div className="">
        <div
          className="px-4 uppercase pb-4 text-ciq-gray-900 text-opacity-90 font-medium"
          data-testid="viewselecteditemsdrawer-title"
        >
          {title} ({items.length})
        </div>
        <ul
          className="list-disc space-y-6 pr-10"
          style={{ overflowY: "auto", height: "calc(100vh - 260px)" }}
          data-testid="viewselecteditemsdrawer-list"
        >
          {items.map((item) => (
            <li
              className="text-opacity-10"
              key={item.pre + item.name}
              data-testid={`viewselecteditemsdrawer-list-item-${
                item.pre + item.name
              }`}
            >
              <span>{item.name}</span> <br />
              <span className="text-ciq-gray-950 text-opacity-80 italic">
                {item.pre}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  );
}
